// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Chart, Plugin, registerables } from 'chart.js';

import { formatNumber } from '../pipes/custom-number.pipe';

export const totalValue = {
  id: 'totalValue',
  beforeInit: function (chart) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;
    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      this.height += 30;
    };
  },
};

export const totalFormatter = (value, ctx) => {
  const stackedValues = ctx.chart.data.datasets.map(
    (ds) => +ds.data[ctx.dataIndex]
  );

  const dsIdxLastVisibleNonZeroValue = stackedValues.reduce(
    (prev, curr, i) =>
      !!curr && !ctx.chart.getDatasetMeta(i).hidden ? Math.max(prev, i) : prev,
    0
  );
  if (!!value && ctx.datasetIndex === dsIdxLastVisibleNonZeroValue) {
    const value = stackedValues
      .filter((ds, i) => !ctx.chart.getDatasetMeta(i).hidden)
      .reduce((sum, v) => sum + v, 0);

    const newValue = Math.trunc(value);

    return formatNumber(newValue, 0);
  } else {
    return '';
  }
};

export const localFormatter = (value) => {
  if (value) {
    return formatNumber(Math.round(value), 0);
  } else {
    return '';
  }
};

export const datalabelsTop = {
  align: 'top',
  anchor: 'end',
  offset: -4,
  font: { weight: 'bold', size: 14 },
  formatter: localFormatter
};

export const datalabelsTotalTop = {
  align: 'top',
  anchor: 'end',
  offset: -4,
  font: { weight: 'bold', size: 14 },
  formatter: totalFormatter
};

export const datalabelsTotalRight = {
  align: 'end',
  anchor: 'end',
  offset: -4,
  font: { weight: 'bold', size: 14 },
  formatter: totalFormatter,
};

export const setBackgroundColorForLabels = (label) => {
  switch (label) {
    case 'Supplier liability':
      return 0;
    case 'No failure found':
      return 1;
    case 'Part not analyzed':
      return 2;
    case 'Part not considered':
      return 3;
    case 'Client liability':
      return 4;
    case 'Out of Warranty':
      return 5;
    default:
      return null;
  }
};

export const drawLabelsBelowBarsPlugin = {
  afterDatasetsDraw: function (chart) {
    const ctx = chart.ctx;
    chart.data.datasets.forEach(function (dataset, i) {
      const meta = chart.getDatasetMeta(i);
      if (!meta.hidden) {
        meta.data.forEach(function (element) {
          ctx.fillStyle = Chart.defaults.color;
          ctx.font = Chart.defaults.font;
          ctx.font = 'bold ' + ctx.font;
          ctx.textAlign = 'center';
          ctx.fillText(dataset.label, element.tooltipPosition().x, chart.height - chart.scales.x.height - chart.scales.x2?.height + 20);
        });
      }
    });
  }
};


export const download = (x: Blob, fileName: string) => {
  const blob = new Blob([x], { type: x.type });
  const blobUrl = globalThis.URL.createObjectURL(blob);
  const aElement = document.createElement('a');
  document.body.appendChild(aElement);
  aElement.style.display = 'none';
  aElement.href = blobUrl;
  aElement.download = fileName;
  aElement.click();
  aElement.remove();
}

export function registerChartPlugins(registerables: any[], totalValue: any) {
  const pluginsToRegister = totalValue ? [...registerables, totalValue] : registerables;
  Chart.register(...pluginsToRegister);
}

export function registerCustomChartPlugins(plugins: (Plugin | null | undefined)[]) {
  const pluginsToRegister = [...registerables, ...plugins.filter((p): p is Plugin => !!p)];
  Chart.register(...pluginsToRegister);
}

export function registerNoDataChartPlugin() {
  Chart.register({
    id: 'NoData',
    afterDraw: function (chart) {
      if (
        chart.data.datasets
          .map((d) => d.data.length)
          .reduce((p, a) => p + a, 0) === 0
      ) {
        const ctx = chart.ctx;
        const width = chart.width;
        const height = chart.height;
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = `1.5rem ${globalThis.getComputedStyle(document.body).fontFamily}`;
        ctx.fillStyle = 'orange';
        ctx.fillText('No data available', width / 2, height / 2);
        ctx.restore();
      }
    },
  });
}
